import React from "react";

import MuiAvatar, { AvatarProps as MuiAvatarProps } from "@mui/material/Avatar";
import styled from "@mui/material/styles/styled";

import { getAvatarSx } from "@app/analytics/utils/uiUtils";
import { getInitials } from "@app/common/utils";

const AVATAR_SIZE_MAP = {
  sm: "32px",
  md: "36px",
  lg: "40px",
};
interface AvatarPropsWithName extends MuiAvatarProps {
  name: string;
  size?: "sm" | "md" | "lg";
}

interface AvatarPropsWithChildren extends Omit<MuiAvatarProps, "children"> {
  name?: string;
  size?: "sm" | "md" | "lg";
  children: React.ReactNode;
}

export type AvatarProps = AvatarPropsWithName | AvatarPropsWithChildren;

const StyledAvatar = styled(MuiAvatar)(({ theme, onClick }) => ({
  borderRadius: "10px",
  fontFamily: theme.typography.fontFamilySecondary,
  fontWeight: "600",
  fontSize: "13px",
  backgroundColor: "none",
  color: "none",
  ...(onClick && {
    "&:hover": {
      cursor: "pointer",
    },
  }),
  "&.focused": {
    border: "2px solid",
    borderColor: theme.palette.shades.primary[500],
  },
}));

const Avatar = ({ name, size = "sm", sx, ...props }: AvatarProps) => {
  const avatarSize = size && AVATAR_SIZE_MAP[size];
  const colorProps = name ? getAvatarSx(name) : {};
  let children = props.children;
  if (name && !props.children) {
    children = getInitials(name);
  }

  return (
    <StyledAvatar
      variant="rounded"
      {...props}
      sx={{
        ...colorProps,
        height: avatarSize,
        width: avatarSize,
        ...sx,
      }}
    >
      {children}
    </StyledAvatar>
  );
};

export default Avatar;
